// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Custom styles to enhance Bootstrap */
.bg-gradient-custom {
  background: linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 50%, #f3e5f5 100%);
}

.backdrop-blur {
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.glass-effect {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.4);
}

.glass-header {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.status-delivered {
  color: white !important;
  background-color: #328a62;
}

.status-pending {
  color: rgb(19, 19, 19) !important;
  background-color: #eccb45;
}

.status-shipped {
  color: white !important;
  background-color: #2476da;
}

.status-cancelled {
  color: white !important; 
  background-color: #d13f3f;
}


.btn-gradient-primary {
  background: linear-gradient(135deg, #2563eb, #4f46e5);
  border: none;
  color: white;
  transition: all 0.2s ease;
}

.btn-gradient-primary:hover {
  background: linear-gradient(135deg, #1d4ed8, #4338ca);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
}

.btn-glass {
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  transition: all 0.2s ease;
}

.btn-glass:hover {
  background: rgba(255, 255, 255, 0.8);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.tab-active {
  background: white;
  color: #2563eb;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.tab-inactive {
  color: #64748b;
  transition: all 0.2s ease;
}

.tab-inactive:hover {
  color: #334155;
  background: rgba(255, 255, 255, 0.5);
}

.timeline-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.timeline-icon-delivered {
  background-color: #d1fae5;
  color: #059669;
}

.timeline-icon-created {
  background-color: #dbeafe;
  color: #2563eb;
}

.timeline-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}


.timeline-icon-updated {
  background-color: #fef3c7;
  color: #d97706;
}

.financial-gradient {
  background: linear-gradient(135deg, #ecfdf5, #eff6ff);
}

.sticky-sidebar {
  position: sticky;
  top: 6rem;
}

.scroll-thin::-webkit-scrollbar {
  width: 6px;
}

.scroll-thin::-webkit-scrollbar-track {
  background: transparent;
}

.scroll-thin::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 3px;
  -webkit-transition: background 0.3s;
  transition: background 0.3s;
}

.scroll-thin::-webkit-scrollbar-thumb:hover {
  background-color: #999;
}

.tab-active {
  background-color: #ebeef1 !important; /* Bootstrap primary */
  color: #fff;
  font-weight: 500;
}

.tab-inactive {
  background-color: #e2e6ea; /* Slightly darker than #f8f9fa */
  color: #495057;
}




@media (max-width: 768px) {
  .sticky-sidebar {
    position: static;
  }
}`, "",{"version":3,"sources":["webpack://./src/containers/Orders/Dummy.css"],"names":[],"mappings":";AACA,uCAAuC;AACvC;EACE,0EAA0E;AAC5E;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,iDAAiD;AACnD;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;;AAGA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,2BAA2B;EAC3B,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mCAA2B;EAA3B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC,EAAE,sBAAsB;EAC5D,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,EAAE,iCAAiC;EAC5D,cAAc;AAChB;;;;;AAKA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["\n/* Custom styles to enhance Bootstrap */\n.bg-gradient-custom {\n  background: linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 50%, #f3e5f5 100%);\n}\n\n.backdrop-blur {\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n}\n\n.glass-effect {\n  background: rgba(255, 255, 255, 0.7);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.4);\n}\n\n.glass-header {\n  background: rgba(255, 255, 255, 0.8);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.status-delivered {\n  color: white !important;\n  background-color: #328a62;\n}\n\n.status-pending {\n  color: rgb(19, 19, 19) !important;\n  background-color: #eccb45;\n}\n\n.status-shipped {\n  color: white !important;\n  background-color: #2476da;\n}\n\n.status-cancelled {\n  color: white !important; \n  background-color: #d13f3f;\n}\n\n\n.btn-gradient-primary {\n  background: linear-gradient(135deg, #2563eb, #4f46e5);\n  border: none;\n  color: white;\n  transition: all 0.2s ease;\n}\n\n.btn-gradient-primary:hover {\n  background: linear-gradient(135deg, #1d4ed8, #4338ca);\n  color: white;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);\n}\n\n.btn-glass {\n  background: rgba(255, 255, 255, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.4);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  transition: all 0.2s ease;\n}\n\n.btn-glass:hover {\n  background: rgba(255, 255, 255, 0.8);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.tab-active {\n  background: white;\n  color: #2563eb;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.tab-inactive {\n  color: #64748b;\n  transition: all 0.2s ease;\n}\n\n.tab-inactive:hover {\n  color: #334155;\n  background: rgba(255, 255, 255, 0.5);\n}\n\n.timeline-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.timeline-icon-delivered {\n  background-color: #d1fae5;\n  color: #059669;\n}\n\n.timeline-icon-created {\n  background-color: #dbeafe;\n  color: #2563eb;\n}\n\n.timeline-icon {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n\n.timeline-icon-updated {\n  background-color: #fef3c7;\n  color: #d97706;\n}\n\n.financial-gradient {\n  background: linear-gradient(135deg, #ecfdf5, #eff6ff);\n}\n\n.sticky-sidebar {\n  position: sticky;\n  top: 6rem;\n}\n\n.scroll-thin::-webkit-scrollbar {\n  width: 6px;\n}\n\n.scroll-thin::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.scroll-thin::-webkit-scrollbar-thumb {\n  background-color: #ccc;\n  border-radius: 3px;\n  transition: background 0.3s;\n}\n\n.scroll-thin::-webkit-scrollbar-thumb:hover {\n  background-color: #999;\n}\n\n.tab-active {\n  background-color: #ebeef1 !important; /* Bootstrap primary */\n  color: #fff;\n  font-weight: 500;\n}\n\n.tab-inactive {\n  background-color: #e2e6ea; /* Slightly darker than #f8f9fa */\n  color: #495057;\n}\n\n\n\n\n@media (max-width: 768px) {\n  .sticky-sidebar {\n    position: static;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
